export const SET_ACTIVITY_POPUP = 'SET_ACTIVITY_POPUP';
export const TOGGLE_ACTIVITY_POPUP = 'TOGGLE_ACTIVITY_POPUP';
export const UPDATE_ACTIVITY_POPUP_INFO = 'UPDATE_ACTIVITY_POPUP_INFO';


// WEBPACK FOOTER //
// ./src/store/modules/popup/mutations.js